import { z } from 'zod'

// Rows are synced from custom UI (placeholders allowed). Submission validates in the form handler.
const jobAssignmentSchema = z.object({
  userId: z.string().optional(),
  roleId: z.string().optional(),
  role: z.string().optional(),
  price: z.number().nullable().optional(),
  payType: z.enum(['job', 'hourly']).optional(),
  hourlyRate: z.number().nullable().optional(),
})

export const jobLogSchema = z.object({
  title: z.string().min(1, 'Title is required'),
  description: z.string().optional(),
  location: z.string().optional(),
  notes: z.string().optional(),
  jobId: z.string().optional(),
  contactId: z.string().optional(),
  price: z.number().nullable().optional(),
  serviceId: z.string().optional(),
  assignedTo: z.array(jobAssignmentSchema).optional(),
  status: z.enum(['active', 'completed', 'inactive']).optional(),
})

export type JobLogFormData = z.infer<typeof jobLogSchema>
